import React from "react";
import { Headline } from "../GenericComponents/Headline";

export interface WorkingGroupPageContainerProps {
  history: any;
}

export interface WorkingGroupPageContainerState {}

class WorkingGroupContainer extends React.Component<
  WorkingGroupPageContainerProps,
  WorkingGroupPageContainerState
> {
  componentDidMount() {}

  render() {
    return (
      <div className="informational-page">
        <Headline history={this.props.history} />
        <div className="informational-content">
          <h2>What articles should I cite when I use this webserver?</h2>

          <h3>
            <u>
              Main publication
            </u>
          </h3>
          <p>
            Gebhardt, C., Bawidamann, P., Spring, A.-K., Schenk, R., Schütze, K., Moya Muñoz, G. G., Wendler, N. D., Griffith, D. A., Lipfert, J., and Cordes, T. (2025).
            “Labelizer: systematic selection of protein residues for covalent fluorophore labeling”, <i>Nature Communications</i> 16, 4147. {" "}
            <a href="https://www.nature.com/articles/s41467-025-58602-y">(Link)</a>
          </p>
          <br />

          <h3>
            <u>
              Please cite additionally for the conservation score, solvent accessibility and AV clouds:
            </u>
          </h3>
          <p>
            Ashkenazy H., Abadi S., Martz E., Chay O., Mayrose I., Pupko T., and Ben-Tal N. (2016) “ConSurf 2016: an improved methodology to estimate and visualize evolutionary conservation in macromolecules”, <i>Nucleic Acids Research</i>, 44, 344.
          </p>
          <p>
            Sanner, M. F., Olson, A. J. & Spehner, J.-C. (1996) “Reduced surface: An efficient way to compute molecular surfaces”, <i>Biopolymers</i>, 38, 305.
          </p>
          <p>
            Kalinin, S., Peulen, T., Sindbert, S., Rothwell, P. J., Berger, S., Restle, T., Goody, R. S., Gohlke, H., & Seidel, C. A. M. (2012). “A toolkit and benchmark study for FRET-restrained high-precision structural modeling” <i>Nature Methods</i>, 9, 1218.
          </p>

          <h2>Who we are?</h2>
          <p>
            This webserver is currently run by scientists of the Chair for Physical Chemistry I at TU Dortmund University in Germany (group of Thorben Cordes). 
            <a href="https://ccb.tu-dortmund.de/en/professorships/pc/cordes/" target="_blank" rel="noopener noreferrer">https://ccb.tu-dortmund.de/en/professorships/pc/cordes/</a>
            The project was initiated by Christian Gebhardt, Jan Lipfert 
            <a href="https://www.uni-augsburg.de/de/fakultaet/mntf/physik/groups/exp1/team/prof-dr-jan-lipfert/" target="_blank" rel="noopener noreferrer"> (profile)</a> and Thorben Cordes in 2017 at LMU Munich in Germany as part of a PhD project.
            Subsequently, the webserver was set up by Christian Gebhardt, Pascal Bawidamann and Robin Schenk, and is currently maintained and further developed by Thomas-Otavio Peulen 
            <a href="https://ccb.tu-dortmund.de/en/professorships/pc/team-cordes/" target="_blank" rel="noopener noreferrer">(team)</a>.
          </p>
          <div style={{ textAlign: "center", marginTop: 16 }}>
            <img src="/People.png" alt="People" style={{ maxWidth: "100%", height: "auto" }} />
          </div>
          <br />
        </div>
      </div>
    );
  }
}

export default WorkingGroupContainer;
